// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1OQVJ","inputWrap":"styles_inputWrap__1swkF","input":"styles_input__2ehuu"};